import { Put, Post, Delete } from "./common";

export default class MessageTemplateService {
  static list = async (token: string, data: any) =>
    await Post({ path: "message-templates/list", token, body: data });

  static create = async (token: string, data: any) =>
    await Post({ path: "message-templates", token, body: data });

  static update = async (token: string, data: any) =>
    await Post({ path: "message-templates/update", token, body: data });

  static updateStatus = async (id: string, token: string, data: any) =>
    await Put({ path: `message-templates/${id}`, token, body: data });

  static deleteById = async (id: string, token: string) =>
    await Delete({ path: `message-templates/${id}`, token });
}
